import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="auto-download"
//
// Auto-clicks the [data-auto-download-target="link"] anchor on connect so the
// browser triggers a download. Stimulus controllers reliably reconnect when
// inserted via Turbo Stream updates, where inline <script> tags often do not.
//
// Use the `key` value to dedupe across reloads — once a key has fired in this
// session it will not fire again.
export default class extends Controller<HTMLElement> {
  static targets = ["link"];
  static values = { key: String };

  declare linkTarget: HTMLAnchorElement;
  declare hasLinkTarget: boolean;
  declare keyValue: string;

  connect() {
    if (!this.hasLinkTarget) return;

    if (this.keyValue) {
      const storageKey = `auto_download:${this.keyValue}`;
      if (sessionStorage.getItem(storageKey)) return;
      sessionStorage.setItem(storageKey, "1");
    }

    this.linkTarget.click();
  }
}
